module.exports = __webpack_public_path__ + "img/reset_doorbell_step_3.b104672a.png";